import React, { useEffect, useState } from 'react'
import { Field, Form, Formik } from 'formik'
import { Button, Grid, MenuItem } from '@material-ui/core'
import { TextField } from 'formik-material-ui'
import { metodoPrograma } from '../../../components/api'

export const Cadastro = ({ objeto, voltar }) => {
  const [pais, setPais] = useState([])
  const [paisSelecionado, setPaisSelecionado] = useState(undefined)
  const [estado, setEstado] = useState([])
  const initialValues = {
    cdPais: objeto?.[0] || undefined,
    ufEstado: objeto?.[1] || undefined,
    idCidade: objeto?.[2] || undefined,
    nmCidade: objeto?.[3] || undefined,
  }

  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }
  useEffect(() => {
    const fetchEstado = async () => {
      const res = await metodoPrograma('listaEstado', {
        cdPais: paisSelecionado,
      })
      console.log('res', res)
      if (res.status) {
        setEstado(res.lista)
      }
    }
    fetchEstado()
  }, [paisSelecionado])

  useEffect(() => {
    const fetchPaises = async () => {
      const res = await metodoPrograma('listaPais', {})
      console.log('res', res)
      if (res.status) {
        setPais(res.lista)
      }
    }
    fetchPaises()
  }, [])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, setFieldValue, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Field
                component={TextField}
                label="País"
                name="cdPais"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
                select
                onChange={(e) => {
                  setPaisSelecionado(e.target.value)
                  setFieldValue('cdPais', e.target.value)
                }}
              >
                {pais.map((item) => (
                  <MenuItem value={item[0]} key={item[1]}>
                    {item[1]}
                  </MenuItem>
                ))}
              </Field>
            </Grid>
            <Grid item xs={6}>
              <Field
                component={TextField}
                label="Estado"
                name="ufEstado"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
                select
              >
                {estado.map((item) => (
                  <MenuItem value={item[1]} key={item[2]}>
                    {item[2]}
                  </MenuItem>
                ))}
              </Field>
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="idCidade"
                label="Código Cidade IBGE"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={9}>
              <Field
                component={TextField}
                name="nmCidade"
                label="Nome Cidade"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}
